import React from "react";
import { useUserContext } from "@/contexts/user/useUserContext";

interface IsConnectedWrapperProps {
  children: React.ReactNode;
}

const IsConnectedWrapper: React.FC<IsConnectedWrapperProps> = ({ children }) => {
  const { user } = useUserContext();
  if (!user?.username || Object.keys(user || {}).length === 0) {
    return null;
  }
  return <>{children}</>;
};

export default IsConnectedWrapper;
